import React, { Fragment, useState, useContext, useEffect } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom'; // Corrected import for useParams
import { updateData, postData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { Tooltip } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SaveIcon from '@mui/icons-material/Save';

const BankCreate = () => {
    const { id: recordId } = useParams(); // Use useParams to get the record ID from the URL
    const history = useHistory();
    const { isAuthenticated, companyId, branchId, userId, logout, token } = useAuth();
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [successMessage, setSuccessMessage] = useState('');

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated, companyId, branchId, token, logout]);

    const [formData, setFormData] = useState({
        BankName: '',
        IFSC: '',
        AccountNo: '',
        Branch: '',
        IsPayable: true,
        OpeningBalance: 0,
        CompanyId: companyId,
    });

    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? checked : type === 'radio' ? value === 'true' : value,
        }));
    };

    const submitData = (event) => {
        event.preventDefault();
        setIsLoading(true);

        const CreateData = {
            ...formData,
            UpdatedBy: userId,
            CompanyId: companyId,
        };

        if (!formData.BankName) { // Check if the category is selected
            setErrorMessage("Name is required!");
            setIsLoading(false);
            return;
        }

        if (!formData.AccountNo) { // Check if the category is selected
            setErrorMessage("Account Number is required!");
            setIsLoading(false);
            return;
        }

        if (!formData.IFSC) { // Check if the category is selected
            setErrorMessage("IFSC Code is required!");
            setIsLoading(false);
            return;
        }



        postData('BankApi', CreateData, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);
                history.push('/BankIndex');
            })
            .catch((error) => {
                console.error('Error updating record:', error);
                setIsLoading(false);
            });
    };

    const phoneNumberPattern = /^\d{10}$/;
    const emailPattern = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}$/;

    // return (
    //     <Fragment>
    //         <div className="w-full max-w-full md:max-w-sm container mt-6 mx-auto px-4">

    //             <form onSubmit={submitData}>

    //                 <div className='w-full mb-2 flex flex-col md:flex-row items-center'>
    //                     <h6 className='productHead flex-grow linkcolor text-center md:text-left' style={{ color: 'black', fontFamily: 'Georgia, serif', fontWeight: 'bolder' }}>
    //                         BANK CREATE
    //                     </h6>
    //                     <div className='flex flex-col md:flex-row md:items-center md:ml-4'>
    //                         <Tooltip title="Exit">
    //                             <Link to="/bankindex" style={{ color: 'red', textDecoration: 'none', fontWeight: 'bolder' }}>
    //                                 <Button style={{ color: 'brown', fontWeight: 'bolder', marginBottom: '10px' }}>
    //                                     Back To List <ArrowForwardIosIcon />
    //                                 </Button>
    //                             </Link>
    //                         </Tooltip>
    //                         <Tooltip title="SAVE">
    //                             <Button onClick={submitData} style={{ color: 'green', fontWeight: 'bolder', marginLeft: '10px', marginTop: '-10px' }} disabled={isLoading}>
    //                                 {isLoading ? <CircularProgress size={24} color="inherit" /> : "SAVE"} <CheckCircleIcon />
    //                             </Button>
    //                         </Tooltip>
    //                     </div>
    //                 </div>

    //                 <br />

    //                 <div className="w-full mb-4 flex flex-col md:flex-row">

    //                     <div className="w-full md:w-1/2 mb-4 md:mb-0 md:mr-2">
    //                         <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="contactNumber1">
    //                             Name
    //                         </label>
    //                         <input
    //                             className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
    //                             name="BankName"
    //                             value={formData.BankName}
    //                             onChange={handleChange}
    //                             type="text"
    //                             placeholder="Enter name"
    //                             required
    //                             maxLength={50}
    //                         />
    //                     </div>

    //                     <div className="w-full md:w-1/4 mb-4 md:mb-0 md:mr-2">
    //                         <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="contactNumber1">
    //                             IFSC Code
    //                         </label>
    //                         <input
    //                             className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
    //                             name="IFSC"
    //                             value={formData.IFSC}
    //                             onChange={handleChange}
    //                             type="text"
    //                             placeholder="Enter IFSC Code"
    //                             required
    //                             maxLength={30}
    //                         />
    //                     </div>

    //                     <div className="w-full md:w-1/4 mb-4 md:mb-0 md:mr-2">
    //                         <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="email">
    //                             Account Number
    //                         </label>
    //                         <input
    //                             className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
    //                             name="AccountNo"
    //                             value={formData.AccountNo}
    //                             onChange={handleChange}
    //                             type="text"
    //                             placeholder="Enter Account Number"
    //                             maxLength={40}
    //                         />
    //                     </div>

    //                     <div className="w-full md:w-1/3 mb-4 md:mb-0 md:mr-2">
    //                         <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="email">
    //                             Branch Name
    //                         </label>
    //                         <input
    //                             className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
    //                             name="Branch"
    //                             value={formData.Branch}
    //                             onChange={handleChange}
    //                             type="text"
    //                             placeholder="Enter Branch"
    //                             maxLength={50}
    //                         />
    //                     </div>

    //                 </div>

    //                 <div className="w-full mb-4 flex flex-col md:flex-row">

    //                     <div className="w-full md:w-1/4 mb-4 md:mb-0 md:mr-2">
    //                         <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="openingBalance">
    //                             Opening Balance
    //                         </label>
    //                         <input
    //                             className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
    //                             name="OpeningBalance"
    //                             value={formData.OpeningBalance}
    //                             onChange={handleChange}
    //                             type="number"
    //                             placeholder="Enter Opening Balance"
    //                         />
    //                     </div>

    //                     <div className="w-full md:w-1/4 mb-4 md:mb-0 md:mr-2">
    //                         <div className="inline-flex items-center">
    //                             <input
    //                                 type="checkbox"
    //                                 className="form-checkbox h-4 w-4 text-green-500 border-4 border-gray-400 rounded-md checked:bg-green-500 checked:border-transparent"
    //                                 name="IsPayable"
    //                                 checked={formData.IsPayable}
    //                                 onChange={handleChange}
    //                                 style={{ marginTop: '35px', marginLeft: '20px' }}
    //                             />
    //                             <span className="ml-2" style={{ marginTop: '35px' }}>Is Payable?</span>
    //                         </div>
    //                     </div>

    //                     <div className="w-2/4 mr-2">
    //                         <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="name">
    //                             Payment QR UPI Id
    //                         </label>
    //                         <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
    //                             name='PaymentQRcodeUPIID'
    //                             value={formData.PaymentQRcodeUPIID}
    //                             onChange={handleChange} type="text"
    //                             placeholder="Enter UPI Id" />
    //                     </div>

    //                     <div className="w-2/4 mr-2">
    //                         <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="name">
    //                             Payment QR UPI Name
    //                         </label>
    //                         <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
    //                             name='UPIName'
    //                             value={formData.UPIName}
    //                             onChange={handleChange}
    //                             type="text"
    //                             placeholder="Enter UPI Name" />
    //                     </div>

    //                     <div className="w-1/4 mr-2">
    //                         <div className="inline-flex items-center">
    //                             <input
    //                                 type="checkbox"
    //                                 className="form-checkbox h-4 w-4 text-green-500 border-4 border-gray-400 rounded-md checked:bg-green-500 checked:border-transparent"
    //                                 name="IsPrimary"
    //                                 checked={formData.IsPrimary}
    //                                 onChange={handleChange}
    //                                 style={{ marginTop: '35px', marginLeft: '20px' }}
    //                             />
    //                             <span className="ml-2" style={{ marginTop: '35px' }}>Is Primary?</span>
    //                         </div>
    //                     </div>
    //                 </div>
                    
    //             </form>
    //         </div>
    //     </Fragment>
    // );
  return (
        <div className="form-container">
            <div className="form-card">
                {/* Header */}
                <div className="form-header">
                    <h1 className="form-title">Create Bank</h1>
                    <div className="form-actions">
                        <Link to="/BankIndex" className="btn-back">
                            <ArrowBackIcon fontSize="small" />
                            Back to List
                        </Link>
                        <button className="btn-save" onClick={submitData} disabled={isLoading}>
                            {isLoading ? (
                                <CircularProgress size={18} color="inherit" />
                            ) : (
                                <>
                                    <SaveIcon fontSize="small" />
                                    Save
                                </>
                            )}
                        </button>
                    </div>
                </div>

                {/* Messages */}
                {errorMessage && <div className="message error">{errorMessage}</div>}
                {successMessage && <div className="message success">{successMessage}</div>}

                {/* Form Body */}
                <div className="form-body">
                    {/* Row 1 - Bank Name */}
                    <div className="form-row">
                        <div className="form-group full-width">
                            <label className="form-label">Bank Name *</label>
                            <input
                                className="form-input"
                                name="BankName"
                                value={formData.BankName || ''}
                                onChange={handleChange}
                                type="text"
                                placeholder="Enter bank name"
                                maxLength={50}
                            />
                        </div>
                    </div>

                    {/* Row 2 - IFSC, Account, Branch, Balance, Payable */}
                    <div className="form-row">
                        <div className="form-group">
                            <label className="form-label">IFSC Code *</label>
                            <input
                                className="form-input"
                                name="IFSC"
                                value={formData.IFSC || ''}
                                onChange={handleChange}
                                type="text"
                                placeholder="Enter IFSC code"
                                maxLength={30}
                            />
                        </div>
                        <div className="form-group">
                            <label className="form-label">Account Number *</label>
                            <input
                                className="form-input"
                                name="AccountNo"
                                value={formData.AccountNo || ''}
                                onChange={handleChange}
                                type="text"
                                placeholder="Enter account number"
                                maxLength={40}
                            />
                        </div>
                        <div className="form-group">
                            <label className="form-label">Branch Name</label>
                            <input
                                className="form-input"
                                name="Branch"
                                value={formData.Branch || ''}
                                onChange={handleChange}
                                type="text"
                                placeholder="Enter branch name"
                                maxLength={50}
                            />
                        </div>
                        <div className="form-group">
                            <label className="form-label">Opening Balance</label>
                            <input
                                className="form-input"
                                name="OpeningBalance"
                                value={formData.OpeningBalance || ''}
                                onChange={handleChange}
                                type="number"
                                placeholder="0.00"
                                style={{ textAlign: 'right' }}
                            />
                        </div>
                        <div className="form-group">
                            <label className="form-label">&nbsp;</label>
                            <div style={{ display: 'flex', alignItems: 'center', height: '42px', gap: '8px' }}>
                                <input
                                    type="checkbox"
                                    name="IsPayable"
                                    checked={formData.IsPayable || false}
                                    onChange={handleChange}
                                    style={{ width: '18px', height: '18px', accentColor: '#1e3a5f', cursor: 'pointer' }}
                                />
                                <span style={{ fontSize: '14px', color: '#475569' }}>Is Payable?</span>
                            </div>
                        </div>
                    </div>

                    {/* Row 3 - UPI Details */}
                    <div className="form-row">
                        <div className="form-group">
                            <label className="form-label">Payment QR UPI ID</label>
                            <input
                                className="form-input"
                                name="PaymentQRcodeUPIID"
                                value={formData.PaymentQRcodeUPIID || ''}
                                onChange={handleChange}
                                type="text"
                                placeholder="Enter UPI ID"
                            />
                        </div>
                        <div className="form-group">
                            <label className="form-label">Payment QR UPI Name</label>
                            <input
                                className="form-input"
                                name="UPIName"
                                value={formData.UPIName || ''}
                                onChange={handleChange}
                                type="text"
                                placeholder="Enter UPI name"
                            />
                        </div>
                        <div className="form-group">
                            <label className="form-label">&nbsp;</label>
                            <div style={{ display: 'flex', alignItems: 'center', height: '42px', gap: '8px' }}>
                                <input
                                    type="checkbox"
                                    name="IsPrimary"
                                    checked={formData.IsPrimary || false}
                                    onChange={handleChange}
                                    style={{ width: '18px', height: '18px', accentColor: '#059669', cursor: 'pointer' }}
                                />
                                <span style={{ fontSize: '14px', color: '#475569' }}>Is Primary?</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

};

export default BankCreate;
